import React from 'react';
import { useLeadCapture } from '../../context/LeadCaptureContext';

export default function DemoRequestButton({
  children,
  source = 'unknown',
  className = 'geotrim-btn geotrim-btn--primary',
  type = 'button',
  ...rest
}) {
  const { openDemoModal } = useLeadCapture();

  return (
    <button
      type={type}
      className={className}
      onClick={() => openDemoModal({ source })}
      {...rest}
    >
      {children}
    </button>
  );
}
